import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AssetMapService {

  assetMap$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) {
    this.assetMap$ = new BehaviorSubject(null);
   }

   loadAssetMap(accountId:number,versionId:number) {
    
    this.assetMap$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('accountid', accountId.toString())
    .set('versionid', versionId.toString())

    this.http.get("/api/data/assetmap",{ params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.assetMap$.next({"loading":false,data:rtn});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get asset map');
        console.log(error);
      }
    );
  }


  
  updateAssetMap(data:object){

    // put on the spinner
    let olddata = this.assetMap$.getValue().data;
    this.assetMap$.next({"loading":true,data:olddata});

    //
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.http.post("/api/data/assetmap", data, {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          
          
          // update the data if the id is already there, or add if its not
          // returned as an array with possible multiple values
          let data = this.assetMap$.getValue().data;
                    
          response.data.forEach(rtndata => {
            const rtnid = rtndata["id"];
            let found = false;
            data.forEach((x,i) => {
              if(x["id"]==rtnid){
                found = true;
                data[i] = rtndata;
              }
            });
  
            if(!found) data.push(rtndata);          
          });

          // publish the new data
          // console.log(data)
          this.assetMap$.next({"loading":false,data:data});

        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Asset Map"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

  deleteAssetMapData(data: any[]) {
    const olddata = this.assetMap$.getValue().data;
    this.assetMap$.next({ 'loading': true, data: olddata });

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: headers,
      body: data
    };

    this.http.delete('/api/data/assetmaps', options).subscribe((res: any) => {
      if (res.success) {
        let oriData = [...this.assetMap$.getValue().data];

        if (Array.isArray(data)) {
          oriData = oriData.filter(itm => {
            const removedItem = data.find(dItem => dItem.id === itm.id);
            return !removedItem;
          });
        }

        this.assetMap$.next({ 'loading': false, data: oriData });
      }
    }, (error: any) => {
      const message = 'Unable to update the Asset Map';
      const snackBarRef = this.snackBar.open(message, '', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
      console.log(message + ' > ' + JSON.stringify(error));

      setTimeout(() => {
        document.location.reload();
      }, 1000);
    });
  }

  loadAccountsFiltering(filter) {
    this.assetMap$.next({"loading":true,data:[]});
    let params = new HttpParams().set('filter', filter);
    this.http.get("/api/data/accountsfilters", { params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.assetMap$.next({"loading":false,data:rtn});
      }, (error: any) => {
        console.log('unable to get Filtering: ' + filter);
        console.log(error);
      }
    );
  }

}
